var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"check","className":"cls-1","d":"M11.884,21.995a1.777,1.777,0,0,1-1.12-.369L3.772,15.768a1.153,1.153,0,0,1-.053-1.887,1.788,1.788,0,0,1,1.149-.42,1.824,1.824,0,0,1,1.172.377l5.122,2.972a.772.772,0,0,0,.522.137.7.7,0,0,0,.471-.224L24.3,4.53a1.7,1.7,0,0,1,1.079-.523A1.913,1.913,0,0,1,26.6,4.27a1.169,1.169,0,0,1,.32,1.866L13.2,21.45a1.765,1.765,0,0,1-1.174.52.291.291,0,0,1-.134.022Z","transform":"translate(-3.254 -3.995)"}));
}

Check.defaultProps = {"width":"24px","height":"18px","viewBox":"0 0 24 18"};

module.exports = Check;

Check.default = Check;
